import React, { FC, useState, useEffect } from 'react';

import { CentralKitchen } from 'models/entities/central-kitchen';
import { CompanyCollection } from 'models/entities/company';
import { Model } from './index.model';

import { useModal } from '../../services/use-modal';
import { TextInput } from 'views/components/text-input';
import { CompanyInput } from './views/company-input';
import { PrimaryButton, SecondaryButton, SecondaryRoundButton } from 'views/components/buttons';
import { TrashIcon } from 'views/components/icons';
import { Root, Footer, MoreActions } from '../edit-franchisor/index.styled';

interface Props {
  target: CentralKitchen;
  companies: CompanyCollection;
  ready: boolean;
}

const EditCentralKitchen: FC<Props> = ({ target, companies, ready }) => {

  const modal = useModal();
  const [model, setModel] = useState(new Model({ target, companies }));

  function save() {
    model.save().then(model => modal.close({ state: model.isNew ? 'created' : 'updated', target: model.result }));
  }

  function cancel() {
    modal.close();
  }

  function remove() {
    if (model.isNew) return;
    model.delete().then(model => modal.close({ state: 'deleted', target: model.result }));
  }

  function watchTarget() {
    if (!model.target?.id) return;
    model.readRelationships(model.target.id).then(m => setModel(m));
  }

  useEffect(watchTarget, [model.target]);

  return (
    <Root>
      <h1>Central Kitchen</h1>
      <fieldset>
        <CompanyInput model={model} onUpdate={m => setModel(m)} inFocus={ready} />
        <TextInput value={model.name} onChange={e => setModel(model.change({ name: e.target.value }))}>
          <h2>Name</h2>
        </TextInput>
      </fieldset>
      <Footer>
        <SecondaryButton onClick={() => cancel()}>Cancel</SecondaryButton>
        <PrimaryButton onClick={() => save()} disabled={!model.result}>Save</PrimaryButton>
      </Footer>
      {!model.isNew && (
        <MoreActions>
          <div>
            <SecondaryRoundButton onClick={() => remove()} disabled={!model.canDelete} tabIndex={-1}><TrashIcon /></SecondaryRoundButton>
          </div>
        </MoreActions>
      )}
    </Root>
  );

};

export { EditCentralKitchen };
